import { render } from "./Artist.vue?vue&type=template&id=fd47f45e&scoped=true"
import script from "./Artist.vue?vue&type=script&lang=js"
export * from "./Artist.vue?vue&type=script&lang=js"

import "./Artist.vue?vue&type=style&index=0&id=fd47f45e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd47f45e"]])

export default __exports__